import React from 'react';
import ContactUsForm from '../../Components/CommonComponents/ContactUsForm';
import ModalPortal, { MODAL_Z } from '../../Components/CommonComponents/ModalPortal';

/**
 * Modal shell around the shared Contact Us form, opened from Clinic Profile.
 */
const ContactUsPopup = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  // Let the success toast be read before the modal closes itself.
  const handleSubmitted = () => {
    setTimeout(onClose, 1200);
  };

  return (
    <ModalPortal isOpen={isOpen} onClose={onClose}>
      <div className={`fixed inset-0 ${MODAL_Z} flex items-center justify-center p-4`}>
        <div
          onClick={onClose}
          className="absolute inset-0 bg-slate-900/50 backdrop-blur-sm transition-opacity"
          aria-hidden="true"
        />
        <div
          role="dialog"
          aria-modal="true"
          className="relative max-h-[90vh] w-full max-w-lg overflow-y-auto rounded-2xl bg-white p-6 shadow-2xl sm:p-8"
        >
          <ContactUsForm
            submitLabel="Send Email"
            sendingLabel="Sending..."
            onSubmitted={handleSubmitted}
            onCancel={onClose}
          />
        </div>
      </div>
    </ModalPortal>
  );
};

export default ContactUsPopup;
